/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
import angular, { ILocationService } from 'angular';
import { RootScope } from 'app.config';
import { EssentialAppConfig } from '../../src/app/@shared-types/config';
import { SettingsAPIService } from '../api/settings-api.service';

export const enum ConstantTypes {
  AIRBAGS = 'AIRBAGS',
  AVAILABILITY = 'AVAILABILITY',
  BENDING_HEADLIGHTS = 'BENDING_HEADLIGHTS',
  CLIMATIZATION = 'CLIMATIZATION',
  DAYTIMERUNNING_LIGHTS = 'DAYTIMERUNNING_LIGHTS',
  DRIVETRAIN_TYPES = 'DRIVETRAIN_TYPES',
  EFFICIENCY_CLASS = 'EFFICIENCY_CLASS',
  EMISSION_CLASS = 'EMISSION_CLASS',
  EXTERIOR_COLOR_NAME = 'EXTERIOR_COLOR_NAME',
  FUEL_TYPES = 'FUEL_TYPES',
  HEADLIGHT_TYPES = 'HEADLIGHT_TYPES',
  INTERIOR_COLOR_NAME = 'INTERIOR_COLOR_NAME',
  INTERIOR_TYPE = 'INTERIOR_TYPE',
  INVENTORY_STATE = 'INVENTORY_STATE',
  MAX_RESERVATION_DURATION = 'MAX_RESERVATION_DURATION',
  RADIO_TYPES = 'RADIO_TYPES',
  SPEED_CONTROL = 'SPEED_CONTROL',
  TRANSMISSION_TYPES = 'TRANSMISSION_TYPES',
  VEHICLE_CATEGORY = 'VEHICLE_CATEGORY',
  VEHICLE_CLASS = 'VEHICLE_CLASS',
  VEHICLE_MANUFACTURER = 'VEHICLE_MANUFACTURER',
  EMISSION_STICKER = 'EMISSION_STICKER',
  TRAILER_COUPLING = 'TRAILER_COUPLING',
  DOOR_COUNT = 'DOOR_COUNT',
  SLIDING_DOORS = 'SLIDING_DOORS',
  BREAKDOWN_KIT = 'BREAKDOWN_KIT',
  PLUG_TYPES = 'PLUG_TYPES',
  BUILDING_BLOCK_TYPES = 'BUILDING_BLOCK_TYPES',
  INPUT_TYPES = 'INPUT_TYPES',
  VEHICLE_FIELDS = 'VEHICLE_FIELDS',
  OPTION_BLOCK_TYPES = 'OPTION_BLOCK_TYPES',
  BIDIRECTIONAL_CHARGING_TYPES = 'BIDIRECTIONAL_CHARGING_TYPES',
}

const constants: { [key in ConstantTypes]: unknown } = {
  VEHICLE_CLASS: {
    CAR: 'Pkw',
    MOTOBIKE: 'Motorrad',
    BUS: 'Bus',
    MOTORHOME: 'Wohnmobil',
    TRUCK_OVER_7500: 'Lkw über 7,5t',
    TRUCK_UPTO_7500: 'Lkw bis 7,5t',
    OTHER: 'Andere Fahrzeugklasse',
  },
  VEHICLE_CATEGORY: {
    CONVERTIBLE: 'Cabriolet',
    ESTATE: 'Kombi',
    LIMOUSINE: 'Limousine',
    OFFROAD: 'Offroad',
    SMALL: 'Kleinwagen',
    SPORTS: 'Sportwagen',
    VAN: 'Van',
    OTHER: 'Andere Fahrzeugkategorie',
  },
  AIRBAGS: {
    DRIVER: 'Fahrerairbag',
    FRONT: 'Frontairbags',
    FRONT_SIDE: 'Front- und Seitenairbags',
    FRONT_SIDE_MORE: 'Front-, Seiten- und weitere Airbags',
  },
  DAYTIMERUNNING_LIGHTS: {
    NORMAL: 'Tagfahrlicht',
    LED: 'LED-Tagfahrtlicht',
  },
  HEADLIGHT_TYPES: {
    BI_XENON: 'Bi-Xenon',
    LASER: 'Laser',
    LED: 'LED',
    XENON: 'Xenon',
  },
  BENDING_HEADLIGHTS: {
    BENDING: 'Kurvenlicht',
    ADAPTIVE: 'Adaptives Kurvenlicht',
  },
  RADIO_TYPES: {
    TUNER: 'Analoges Radio',
    DAB: 'Digitalradio (DAB)',
  },
  SPEED_CONTROL: {
    C: 'Tempomat',
    AC: 'Adaptiver Tempomat',
  },
  DRIVETRAIN_TYPES: {
    A: 'Allradantrieb',
    F: 'Vorderradantrieb',
    B: 'Heckantrieb',
  },
  FUEL_TYPES: {
    PETROL: 'Benzin',
    DIESEL: 'Diesel',
    HYBRID_DIESEL_MILD: 'Mild-Hybrid Diesel',
    HYBRID_DIESEL_PLUGIN: 'Plug-in-Hybrid Diesel',
    HYBRID_PETROL_MILD: 'Mild-Hybrid Benzin',
    HYBRID_PETROL_PLUGIN: 'Plug-in-Hybrid Benzin',
    HYBRID_FULL: 'Voll-Hybrid',
    ELECTRICITY: 'Elektrisch',
    CNG: 'Erdgas',
    ETHANOL: 'Ethanol',
    LPG: 'LPG',
    HYDROGEN: 'Wasserstoff',
    OTHER: 'Anderer Kraftstoff',
  },
  TRANSMISSION_TYPES: {
    AUTOMATIC: 'Automatikgetriebe',
    SEMI_AUTO: 'Halbautomatikgetriebe',
    MANUAL: 'Schaltgetriebe',
  },
  AVAILABILITY: {
    A: 'Verfügbar',
    E: 'Event',
    R: 'Reserviert',
    S: 'Verkauft',
  },
  INVENTORY_STATE: {
    ORDERED: 'Vorlauf',
    STOCK: 'Lager',
    SOLD: 'Ausgeliefert',
  },
  EXTERIOR_COLOR_NAME: {
    BEIGE: 'Beige',
    BLUE: 'Blau',
    BROWN: 'Braun',
    YELLOW: 'Gelb',
    GOLD: 'Gold',
    GREY: 'Grau',
    GREEN: 'Grün',
    ORANGE: 'Orange',
    RED: 'Rot',
    BLACK: 'Schwarz',
    SILVER: 'Silber',
    PURPLE: 'Violett',
    WHITE: 'Weiß',
    OTHER: 'Andere Farbe',
  },
  INTERIOR_COLOR_NAME: {
    BEIGE: 'Beige',
    BROWN: 'Braun',
    GREY: 'Grau',
    BLACK: 'Schwarz',
    RED: 'Rot',
    BLUE: 'Blau',
    OTHER: 'Andere Innenraumfarbe',
  },
  INTERIOR_TYPE: {
    ALCANTARA: 'Alcantara',
    LEATHER: 'Leder',
    FABRIC: 'Stoff',
    PART_LEATHER: 'Teilleder',
    VELOUR: 'Velour',
    FAUX_LEATHER: 'Kunstleder',
    OTHER: 'Anderer Innenraumtyp',
  },
  MAX_RESERVATION_DURATION: 10,
  CLIMATIZATION: {
    NONE: 'Keine Klimaanlage',
    MANUAL: 'Manuelle Klimaanlage',
    AUTO: 'Automatische Klimaanlage',
    AUTO_2: 'Automatische Klimaanlage (2 Zonen)',
    AUTO_3: 'Automatische Klimaanlage (3 Zonen)',
    AUTO_4: 'Automatische Klimaanlage (4 Zonen)',
  },
  EMISSION_STICKER: {
    EU4: 'EU4 (Grün)',
    EU3: 'EU3 (Gelb)',
    EU2: 'EU2 (Rot)',
    NONE: 'Keine',
  },
  EFFICIENCY_CLASS: {
    'A+': 'A+',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
  },
  EMISSION_CLASS: {
    EU1: 'Euro 1',
    EU2: 'Euro 2',
    EU3: 'Euro 3',
    EU4: 'Euro 4',
    EU5: 'Euro 5',
    EU6: 'Euro 6',
    EU6A: 'Euro 6A',
    EU6B: 'Euro 6B',
    EU6C: 'Euro 6C',
    EU6D: 'Euro 6D',
    EU6DTEMP: 'Euro 6D Temp',
    EU6E: 'Euro 6E',
    EU7: 'Euro 7',
  },
  VEHICLE_MANUFACTURER: {
    OTHER: 'Anderer Hersteller',
    FCA: 'FCA',
  },
  TRAILER_COUPLING: {
    ES: 'Elektronisch schwenkbar',
    MS: 'Manuell schwenkbar',
    F: 'Starr',
    D: 'Abnehmbar',
    P: 'Anhängerkupplung-Vorbereitung',
  },
  DOOR_COUNT: {
    '2/3': '2/3',
    '4/5': '4/5',
    '6/7': '6/7',
  },
  SLIDING_DOORS: {
    LM: 'Links (manuell)',
    LA: 'Links (elektrisch)',
    RM: 'Rechts (manuell)',
    RA: 'Rechts (elektrisch)',
    BM: 'Beide Seiten (manuell)',
    BA: 'Beide Seiten (elektrisch)',
  },
  BREAKDOWN_KIT: {
    S: 'Reserverad',
    E: 'Notrad',
    R: 'Pannenkit',
  },
  PLUG_TYPES: {
    TYPE_1: 'Typ 1',
    TYPE_2: 'Typ 2',
    CCS_COMBO: 'CCS/Combo',
    CHADEMO: 'Chademo',
    SCHUKO: 'Schuko',
    TESLA_SC: 'Tesla Supercharger',
  },
  /** Custom Templates: */
  BUILDING_BLOCK_TYPES: {
    SPACER: 'Platzhalter',
    INPUT: 'Eingabefeld',
    TITLE: 'Überschrift',
    TEXT: 'Textblock',
    VEHICLE: 'Fahrzeug',
    CUSTOMER: 'Kunde',
    DEALER: 'Händler',
    SIGNATURE: 'Unterschrift',
    PAGE_BREAK: 'Seitenumbruch',
  },
  INPUT_TYPES: {
    NUMBER: 'Zahl',
    TEXT: 'Text',
    PERCENTAGE: 'Prozent',
    CURRENCY: 'Währung',
    PRICE: 'Preis',
    SELECT: 'Auswahl',
    DATE: 'Datum',
  },
  VEHICLE_FIELDS: {
    TYPE: 'Fahrzeugart',
    SELLER: 'Verkäufer',
  },
  OPTION_BLOCK_TYPES: {
    SERIES: 'Serienoptionen',
    ADDITIONAL: 'Aufpreisoptionen',
    CUSTOM: 'Zusätzliche Ausstattung',
  },
  BIDIRECTIONAL_CHARGING_TYPES: {
    V2G: 'Vehicle-to-Grid (V2G)',
    V2H: 'Vehicle-to-Home (V2H)',
    V2L: 'Vehicle-to-Load (V2L)',
    V2V: 'Vehicle-to-Vehicle (V2V)',
    V2X: 'Vehicle-to-X (V2X)',
    OTHER: 'Andere',
  },
};

export const enum EUserSettings {
  CSV_COMPATABILITY = 'csvExcelCompatability',
}

export class ConfigService {
  private $rootScope: RootScope;

  private settingsApiService: SettingsAPIService;

  private $routeParams: angular.route.IRouteParamsService;

  private $location: ILocationService;

  constructor(
    $rootScope: RootScope,
    settingsApiService: SettingsAPIService,
    $routeParams: angular.route.IRouteParamsService,
    $location: ILocationService,
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.settingsApiService = settingsApiService;
    this.$routeParams = $routeParams;
    this.$location = $location;
  }

  public getPath = (): string => this.$location.path();

  public getRouteParams = (): { [key: string]: string | undefined } => this.$routeParams;

  /** Returns a property of `EssentialAppConfig`.
   * If no value exists for the provided `key` `null` will be returned. */
  public get = <T extends keyof EssentialAppConfig>(key: T): EssentialAppConfig[T] | null => {
    if (this.$rootScope.globals.config === undefined) return null;
    return this.$rootScope.globals.config[key] as EssentialAppConfig[T];
  };

  public getConstant = <T>(key: ConstantTypes): T | null => {
    if (constants[key] === undefined) return null;
    return constants[key] as T;
  };

  public getUserConfig = <T>(key: EUserSettings): T | null => {
    if (!this.$rootScope.globals[key]) return null;
    return this.$rootScope.globals[key] as T;
  };

  public setConfig = (config: EssentialAppConfig): void => {
    this.$rootScope.globals.config = config;
  };
}

export default angular.module('services.configService', [])
  .service('configService', ConfigService)
  .name;
